'use client';

export default function Error({ error }: ErrorPageProps) {
  return (
    <main className="px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <h1 className="mt-4 text-3xl font-bold tracking-tight sm:text-5xl">
          Error
        </h1>
        <p className="mt-6 text-base leading-7">{error.message}</p>
        {error.digest && (
          <>
            <p className="mt-6 text-sm">
              When reporting the error please use the following error reference
            </p>
            <p className="font-bold text-sm">{error.digest}</p>
          </>
        )}
      </div>
    </main>
  );
}
